import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { NavLink, useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import Header from '../Headers/Header';
import ErrorMessage from '../AppLayouts/ErrorMessage';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Css start ....
const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '98%',
        },
    },
    rootBox: {
        flexGrow: 1,
    },
    paper: {
        width: '100%',
        boxShadow: 'none',
        display: 'flex'
    },
    signMain: {
        position: 'relative',
        width: '100%',
        background: 'rgba(0,0,0,.5)',
        top: '0',
        marginTop: '-125px',
        zIndex: '1',
        '@media only screen and (max-width: 1500px)': {
            height: '145vh',
        },
        '@media only screen and (max-width: 3500px) and (min-width: 1501px)': {
            height: '120vh',
        },
        '@media only screen and (min-width: 3501px)': {
            height: '98.4vh',
        },
    },
    signInBtn: {
        border: '1px solid rgba(36, 97, 142, 1)',
        color: '#fff',
        background: 'rgba(36, 97, 142, 1)!important',
        '@media only screen and (max-width: 3500px)': {
            width: '220px',
            fontSize: '14pt',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '360px',
            fontSize: '24pt',
            marginBottom: '10px',
        },
    },
    formLogo: {
        textAlign: 'center',
        width: '100%',
        paddingTop: '15px',
        '& p': {
            textAlign: 'right',
            margin: '0px 0 -20px',
            paddingRight: '15px',
            fontSize: '25px',
        },
        '& a': {
            color: '#24618E',
        }
    },
    rootForm: {
        margin: '10px auto 0',
        border: '1px solid rgba(0, 167, 93, 1)',
        padding: '10px',
        borderRadius: '5px',
        boxShadow: '1px 4px 5px 1px #ccc',
        '@media only screen and (max-width: 3500px)': {
            width: '80%',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '85%',
        },
        '& input#email': {
            padding: '10px',
        },
        '& input#password': {
            padding: '10px',
        },
        '& h3': {
            color: '#24618E',
            marginTop: '0px',
            marginBottom: '0',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '20px',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '26pt',
            },
        },
        '& h4': {
            margin: '0px',
            '@media only screen and (min-width: 3501px)': {
                fontSize: '24pt',
            },
        },
        '& ul': {
            marginTop: '0px',
            paddingLeft: '25px',
        },
        '& input[type="password"]': {
            padding: '10px',
        },
        '& input[type="tel"]': {
            padding: '10px',
        }
    },
    formInput: {
        width: '100%',
    },
    OtherLink: {
        width: '80%',
        margin: '0 auto',
        '& a': {
            color: '#24618E',
        }
    },
    errorInput: {
        width: '100%',
        backgroundColor: '#F2DEDE',
        border: '1px solid #CC0000'
    },
    errIcon: {
        fontSize: '26px',
        color: '#CC0000',
        margin: '2%'
    },
    errMsgReset: {
        '& span': {
            fontSize: '11pt !important'
        },
    },
    userFormContainer: {
        '@media only screen and (max-width: 3500px)': {
            width: '500px',
            paddingTop: '90px',
        },
        '@media only screen and (min-width: 3501px)': {
            width: '650px',
            maxWidth: '650px',
            paddingTop: '250px',
            '& input': {
                fontSize: '22pt',
            }
        },
    },
    closeIcon: {
        '&:hover': {
            color: '#CC0000',
        }
    },
    formIcon: {
        '@media only screen and (max-width: 3500px)': {
            width: '215px',
            height: '50px'
        },
        '@media only screen and (min-width: 3501px)': {
            width: '300px',
            height: '70px'
        },
    },
    timeTextContent: {
        textAlign: 'center', color: '#CC0000',
        '@media only screen and (max-width: 3500px)': {
            fontSize: '18px'
        },
        '@media only screen and (min-width: 3501px)': {
            fontSize: '24pt'
        },
    }
}));
//Css end ....

//Start ResetPassword component code ....
export default function ResetPassword() {
    const [spacing, setSpacing] = React.useState(2);
    const [passwordValues, setPasswordValues] = React.useState({
        pwd: "",
        cnfNewPwd: "",
        confirmationcode: ""
    });
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [errPassword, setErrNewPassword] = React.useState(null);
    const [errCnfPassword, setErrCnfPassword] = React.useState(null);
    const [errCode, setErrCode] = React.useState(null);
    const classes = useStyles();
    let timeInterval;
    let timerInterval;
    let history = useHistory();
    React.useEffect(() => {
        setErrMsg('An email has been sent to the email you provided');
        setErrMsgType('success');
        setErrPopUp(true);
        watcher();
    }, []);
    let min = 4, sec = 60
    
    const validateForm = async e => {        
        let updatebtn = document.getElementById("update_My_btn");
        let showTime = document.getElementById("timeDiv");
        if (updatebtn.value === "Resend Code") {
            min = 4;
            sec = 60
            showTime.innerHTML = "05:00";
            showTime.style.display = "block";
            updatebtn.value = "Update My Password";
            updatebtn.innerHTML = "Update My Password";
            watcher();
            resendCode();
        }
        else {
            recoverPassword();
        }

    }


    const watcher = () => {
        timerInterval = setInterval(function () {
            startTime();
            let showTime = document.getElementById("timeDiv");
            if (sec < 10) {
                if (showTime) {
                    showTime.innerHTML = "0" + min + ":0" + sec;
                }
            }
            else {
                if (showTime) {
                    showTime.innerHTML = "0" + min + ":" + sec;
                }
            }
        }, 1000);
    }

    const startTime = () => {
        let updatebtn = document.getElementById("update_My_btn");
        let showTime = document.getElementById("timeDiv");
        sec--;
        if (sec === 0) {
            sec = 60;
            min--;
            if (min < 0) {
                showTime.style.display = "none";
                updatebtn.value = "Resend Code";
                updatebtn.innerHTML = "Resend Code";
                clearInterval(timerInterval);
            }
        }
    }


    const handleChange = (event) => {
        setSpacing(Number(event.target.value));
    };
    const ShowErrPopUP = () => {
        setErrPopUp(false);
    };

    const passwordHandleChange = name => event => {
        setErrNewPassword(false);
        setErrCnfPassword(false);
        setErrCode(false);
        setPasswordValues({ ...passwordValues, [name]: event.target.value });
    }

    //This code is use for change password form validations ... start
    const passwordValidateForm = async e => { 
        e.preventDefault()
        let passwordCheck = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$.!%*?&]{8,}$/
        let updatebtn = document.getElementById("update_My_btn");
        await setErrMsg(null);

        if (updatebtn.value !== "Resend Code") {
            if (passwordValues.pwd == '') {
                setErrNewPassword(true);
                setErrMsgType('error');
                setErrMsg('New Password required.');
                setErrPopUp(true);
            } else if (!passwordCheck.test(passwordValues.pwd)) {
                setErrNewPassword(true);
                setErrMsgType('error');
                setErrMsg('Password does not meet the criterion.');
                setErrPopUp(true);
            } else if (passwordValues.cnfNewPwd == '') {
                setErrCnfPassword(true);
                setErrMsg('Confirm Password required.');
                setErrPopUp(true);
            } else if (passwordValues.pwd !== passwordValues.cnfNewPwd) {
                setErrCnfPassword(true);
                setErrMsgType('error');
                setErrMsg('The provided passwords do not match');
                setErrPopUp(true);
            } else if (passwordValues.confirmationcode == '') {
                setErrCode(true);
                setErrMsgType('error');
                setErrMsg('Verification code required.');
                setErrPopUp(true);
            } else {
                validateForm();               
            }
        } else {
            validateForm(e);
        }
    }
    //This code is use for change password form validations ... end

    //This code is use for API call to request verification code to recover password .... start
    const recoverPassword = () => { 
        try {
            axios({
                method: 'post',
                data: { ...passwordValues, ...{ 'email': Cookies.get('email') } },
                url: API_URL + API_PATH.confirmForgotPasswordAPI,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        history.push('./password_updated');
                        Cookies.remove('email');                        
                    } else {
                        setErrMsgType('error');
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true);
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        setErrMsgType('error');
                        setErrMsg(error.response.data.message.message);
                        setErrPopUp(true);
                    } else {
                        setErrMsgType('error');
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true);
                    }
                })
        } catch (error) {
            console.error(error);
        }
    }
    //This code is use for API call to request verification code to recover password .... end

    
    //This code is use API call to request verification code to recover password ... start
    const resendCode = () => {
        try {
            axios({
                method: 'post',
                data: { 'email': Cookies.get('email') },
                url: API_URL + API_PATH.forgotPasswordAPI,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        setErrMsgType('success')
                        setErrMsg('An email has been sent to the email you provided.');
                        setErrPopUp(true)
                    } else {
                        setErrMsgType('error')
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true)
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        setErrMsgType('error');
                        setErrMsg(error.response.data.message.message);
                        setErrPopUp(true);
                    } else {
                        setErrMsgType('error');
                        setErrMsg('Something went wrong.');
                        setErrPopUp(true);
                    }
                })
        } catch (error) {
            console.error(error);
        }
    }
    //This code is use API call to request verification code to recover password ... end

    return (
        <React.Fragment>
            <Header />
            <CssBaseline />
            <div className={classes.signMain}>
                <Container maxWidth="sm" className={classes.userFormContainer}>
                    <Typography component="div" style={{ backgroundColor: '#fff', minHeight: '360px', paddingBottom: '10px', position: 'relative', border: '1px solid #24618E', borderRadius: '5px', }}>
                        <div className={classes.formLogo}>
                            <p><NavLink className={classes.closeIcon} to="/" title='Close'><FontAwesomeIcon icon={faTimes} title='Close' /></NavLink></p>
                            <img src={require('../../assets/images/dataPointMainLogo.svg')} className={classes.formIcon}></img>
                        </div>
                        {errMsg ? <div className={classes.errMsgReset}>  <ErrorMessage message={errMsg} visible={ShowErrPopUP} show={errPopUp} msgType={errMsgType} /> </div> : null}
                        <form className={classes.rootForm} noValidate autoComplete="off" onSubmit={e => passwordValidateForm(e)}>
                            <h3>Update My Password</h3>
                            <img src={require('../../assets/images/hrimg.svg')} style={{ marginBottom: '10px', width: '100%', height: '1px' }} />
                            <Grid container className={classes.rootBox} spacing={spacing}>
                                <Grid item xs={12}>
                                    <Grid container justify="center" spacing={spacing}>
                                        <Grid xs={12} item>
                                            <Paper className={classes.paper} >
                                                <h4>Password should:</h4>
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <Paper className={classes.paper} >
                                                <ul>
                                                    <li>be at least 8 characters long</li>
                                                    <li>contain at least 1 number, 1 upper-case letter, and 1 lower-case letter</li>
                                                    <li>contain at least 1 special character</li>
                                                    <li>not contain your name or email address</li>
                                                </ul>
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <Paper className={classes.paper} >
                                                <TextField id="new_password" data-testid="new_password" className={errPassword ? classes.errorInput : classes.formInput} placeholder="New Password *" type="password" variant="outlined" required onChange={passwordHandleChange('pwd')} />
                                                {errPassword ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <Paper className={classes.paper} >
                                                <TextField id="confirm_new_password" data-testid="confirm_new_password" className={errCnfPassword ? classes.errorInput : classes.formInput} placeholder="Confirm New Password *" type="password" variant="outlined" required onChange={passwordHandleChange('cnfNewPwd')} />
                                                {errCnfPassword ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <Paper className={classes.paper} >
                                                <TextField id="verification_code" data-testid="verification_code" className={errCode ? classes.errorInput : classes.formInput} placeholder="Verification Code *" type="tel" variant="outlined" required onChange={passwordHandleChange('confirmationcode')} />
                                                {errCode ? <FontAwesomeIcon icon={faExclamationCircle} className={classes.errIcon} /> : null}
                                            </Paper>
                                        </Grid>
                                        <Grid xs={12} item>
                                            <div id="timeDiv" className={classes.timeTextContent}>05:00</div>
                                            <Paper className={classes.paper} style={{ textAlign: 'center', display: 'block' }} >
                                                <Button type="submit" variant="outlined" id="update_My_btn" data-testid="update_pw_btn" className={classes.signInBtn} value="Update My Password">
                                                    Update My Password</Button>
                                            </Paper>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                        <div className={classes.OtherLink}>
                            <p style={{ marginBottom: '5px' }}><NavLink to="/sign_in">Sign In</NavLink></p>
                            <p style={{ marginTop: '5px' }}><NavLink to="/sign_up">Sign up for an account</NavLink></p>
                        </div>
                    </Typography>
                </Container>
            </div>
        </React.Fragment>
    );
}
//End ResetPassword component code ....